<mat-icon>developer_board</mat-icon>
<div>Please select any item that can be inspected</div>
